import { useRouter } from 'next/router';
import { FC } from 'react';
import { useQueryClient } from 'react-query';
import { middlewarePostOfGroupFeed } from '../../apis/tms/post.api';
import { checkIsUserJoined } from '../../common/checkRoleUser';
import {
  FEED_LIST_POST_IN_GROUPS,
  GROUP_ROLE_ACCESS,
} from '../../constant/QueryKeyName';
import { GROUP_POST_PAGE_SIZE } from '../../constant/numericParams';
import { ROLE_ACCESS } from '../../constant/storage';
import { TPostInfinityQuery } from '../../interfaces/post.interface';
import PostFeed from '../elements/feed/post';
import CreatePostInput from '../input/PostInput';

const FeedTab: FC<{}> = () => {
  const router = useRouter();
  const { gid: groupId } = router.query;
  const queryFn = middlewarePostOfGroupFeed(groupId as string);
  const queryClient = useQueryClient();

  const mineRole = queryClient.getQueryData([GROUP_ROLE_ACCESS, groupId]);

  return (
    <div className="w-full">
      <div className="w-full lg:max-w-[526px] mx-auto">
        <div className="mb-2 mt-6 -mx-2 md:mx-0 md:p-[0px_16px]">
          {checkIsUserJoined(mineRole as ROLE_ACCESS) && <CreatePostInput />}
        </div>
        <PostFeed
          groupMode={true}
          queryFn={queryFn}
          queryKey={[
            FEED_LIST_POST_IN_GROUPS,
            GROUP_POST_PAGE_SIZE,
            groupId as string,
          ]}
          opt={{
            enabled: !!groupId,
            refetchOnMount: true,
            refetchOnWindowFocus: false,
            keepPreviousData: true,
            cacheTime: 0,
            getNextPageParam: (
              _lastPage: TPostInfinityQuery,
              _allPages: TPostInfinityQuery[]
            ) => {
              return _lastPage?.hasNextPage
                ? _lastPage?.currentPage + 1
                : undefined;
            },
          }}
        />
        {/* <PostFeed /> */}
      </div>
    </div>
  );
};

export default FeedTab;
